export enum ICON_TYPE {
    CALENDAR = 'CALENDAR',
    DELETE = 'DELETE',
    IMAGE = 'IMAGE',
    PDF = 'PDF',
    INFO = 'INFO'
}
